import React from 'react';
import SvgIcon, {SvgIconProps} from '@material-ui/core/SvgIcon';

function AtLeastGateIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <g
        id="layer1"
        transform="translate(0,8)">
        <g
          id="g4630"
          transform="matrix(0.50799791,0,0,0.50799791,19.64245,-1.0564844)">
          <path
            id="path5186-4"
            opacity="0.3"
            fill="white"
            d="m -35.253257,33.446462 2.508648,-1.913306 c 0,0 7.204382,-5.411035 18.075144,-5.411035 10.8707783,0 18.0751283,5.411035 18.0751283,5.411035 l 2.508641,1.913306 v -16.41248 c 0,-2.303693 0.02727,-7.3563385 -2.476472,-13.0343215 -2.50171595,-5.67798 -7.557624,-11.993045 -17.3675683,-16.9206995 -0.720852,-0.325774 -0.75861,-0.29794 -1.479461,0 v 0 c -19.622176,9.8564695 -19.84406,25.404299 -19.84406,29.95466 z" />
          <path
            id="path4-4"
            opacity="0.8"
            d="m -35.253257,33.446462 2.508649,-1.923175 c 0,0 7.204374,-5.438981 18.075131,-5.438981 10.8707593,0 18.0751323,5.438981 18.0751323,5.438981 l 2.508649,1.923175 V 16.949223 c 10e-7,-2.315577 0.02522,-7.3943195 -2.476486,-13.1016325 -2.50171595,-5.707312 -8.265177,-12.385524 -18.0751323,-17.3386275 l -0.03216,1.59263 0.03216,-1.59263 c -20.122168,9.7823465 -20.615943,25.866397 -20.615943,30.44026 z m 5.866071,-8.950431 v -7.546808 c 0,-7.9849554 2.25582,-16.84600151 14.717709,-24.573855 7.4093987,4.9001099 9.2570005,6.4258858 12.1860555,11.63466 2.75866414,4.905766 2.5319138,10.624478 2.5319138,12.940054 v 7.547243 c -3.1991659,-1.80162 -6.535247,-4.281408 -14.7179693,-4.281408 -8.206087,0 -11.527413,2.479331 -14.717709,4.280114 z"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export default AtLeastGateIcon;

